import React from 'react';
interface WordmarkProps {
  size?: 'sm' | 'lg';
  onDark?: boolean;
}
const TAGLINE = 'MARKETING & CONVERSIONS';
const HIGHLIGHT = ['R', 'O', 'I'];
export function Wordmark({
  size = 'sm',
  onDark = false
}: WordmarkProps) {
  const isLarge = size === 'lg';
  return <div className="inline-flex flex-col items-start" aria-hidden="true" data-id="element-185" data-mp="2lct0zsd21kl">
      <span className={`font-display font-extrabold leading-none tracking-tight ${isLarge ? 'text-4xl' : 'text-2xl'}`} data-id="element-186" data-mp="6jskpgzdzy4c">
        <span className="text-brand-red" data-id="element-187" data-mp="3ayabzreraqdq">ad</span>
        <span className={onDark ? 'text-brand-white' : 'text-brand-black'} data-id="element-188" data-mp="3b0wg1h2funr7">roi</span>
      </span>
      <span className={`mt-1.5 font-semibold ${onDark ? 'text-brand-white' : 'text-brand-black'} ${isLarge ? 'text-[11px] tracking-[0.24em]' : 'text-[9px] tracking-[0.2em]'}`} data-id="element-189" data-mp="3ez2menzd71bl">
        {TAGLINE.split('').map((char, index) => HIGHLIGHT.includes(char) ? <span key={index} className="text-brand-red" data-id="element-190" data-mp="zbcaxkueicfu">
              {char}
            </span> : <span key={index} data-id="element-191" data-mp="19ifek35eg9rg">{char === ' ' ? '\u00A0' : char}</span>)}
      </span>
    </div>;
}